/*
  cdr-loop-carousel
  Carrossel circular usado nas vitrines da pÃ¡gina de produto.

  Dois modos:
  â€¢ passo a passo (padrÃ£o): anda de card em card pelas setas ou pelo arraste.
    Ã‰ o que roda em "VocÃª tambÃ©m pode gostar" e "Vistos Recentemente".
  â€¢ esteira (data-auto="true"): anda sozinho, sem parar, feito uma faixa
    contÃ­nua. Ã‰ o que roda nas avaliaÃ§Ãµes.

  Nos dois casos o loop Ã© feito clonando os itens das pontas. Na esteira, o
  deslocamento volta ao inÃ­cio assim que completa a largura de um conjunto,
  e como o conteÃºdo Ã© idÃªntico o cliente nÃ£o percebe a emenda.

  Por ser um custom element, connectedCallback / disconnectedCallback sÃ£o
  chamados pelo navegador. Isso resolve o editor de tema: ao recarregar a
  seÃ§Ã£o o elemento antigo morre com seus listeners e o novo nasce limpo, sem
  empilhar handlers nem clones.

  Atributos:
    data-per-xl / data-per-lg / data-per-desktop / data-per-tablet / data-per-mobile
    data-item-mobile     largura fixa do card no celular (ex.: "84vw")
    data-gap-desktop / data-gap-mobile
    data-speed           duraÃ§Ã£o da transiÃ§Ã£o no modo passo a passo (ms)
    data-auto            "true" liga a esteira
    data-auto-speed      velocidade da esteira em pixels por segundo
    data-auto-pause      "true" pausa a esteira com o mouse em cima
*/
(() => {
  if (customElements.get('cdr-loop-carousel')) return;

  class CdrLoopCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.cdrlc__viewport');
      this.track = this.querySelector('.cdrlc__track');
      if (!this.viewport || !this.track) return;

      this.prevBtn = this.querySelector('.cdrlc__arrow--prev');
      this.nextBtn = this.querySelector('.cdrlc__arrow--next');
      this.speed = Number(this.dataset.speed) || 500;
      this.auto = this.dataset.auto === 'true';
      this.velocidade = Number(this.dataset.autoSpeed) || 35;
      this.pausaNoHover = this.dataset.autoPause !== 'false';

      this.semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.limparClones();
      this.originais = Array.from(this.track.children);
      if (!this.originais.length) return;

      this.indice = 0;
      this.offset = 0;
      this.impulso = 0;
      this.pausado = false;
      this.arrastando = false;
      this.emTransicao = false;

      this.montar();

      this.aoRedimensionar = this.debounce(() => this.montar(), 150);
      window.addEventListener('resize', this.aoRedimensionar);

      this.onPrev = () => this.mover(-1);
      this.onNext = () => this.mover(1);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

      if (this.auto && this.pausaNoHover) {
        this.onEnter = () => {
          this.pausado = true;
        };
        this.onLeave = () => {
          this.pausado = false;
        };
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onEnter);
        this.addEventListener('focusout', this.onLeave);
      }

      this.ligarArraste();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.medir());
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      clearTimeout(this.destravar);
      window.removeEventListener('resize', this.aoRedimensionar);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.onEnter) {
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('focusin', this.onEnter);
        this.removeEventListener('focusout', this.onLeave);
      }
      this.desligarArraste();
    }

    debounce(fn, ms) {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }

    limparClones() {
      this.track.querySelectorAll('[data-cdrlc-clone]').forEach((n) => n.remove());
    }

    porTela() {
      const l = document.documentElement.clientWidth;
      if (l >= 1600 && this.dataset.perXl) return Number(this.dataset.perXl);
      if (l >= 1200 && this.dataset.perLg) return Number(this.dataset.perLg);
      if (l >= 990) return Number(this.dataset.perDesktop) || 4;
      if (l >= 750) return Number(this.dataset.perTablet) || 3;
      return Number(this.dataset.perMobile) || 2;
    }

    gapAtual() {
      const l = document.documentElement.clientWidth;
      const g = l >= 750 ? this.dataset.gapDesktop : this.dataset.gapMobile;
      const n = Number(g);
      return Number.isFinite(n) ? n : 30;
    }

    larguraFixaMobile() {
      const v = this.dataset.itemMobile;
      if (!v || document.documentElement.clientWidth >= 750) return null;
      const n = parseFloat(v);
      if (!Number.isFinite(n)) return null;
      return v.trim().endsWith('vw') ? (document.documentElement.clientWidth * n) / 100 : n;
    }

    montar() {
      cancelAnimationFrame(this.raf);
      this.limparClones();
      this.porVez = this.porTela();
      this.gap = this.gapAtual();
      this.track.style.gap = this.gap + 'px';

      this.temLoop = this.originais.length > this.porVez;

      if (this.temLoop) {
        /* na esteira o trilho precisa de fÃ´lego Ã  direita para o tempo todo
           existir card entrando na tela */
        const voltas = this.auto ? 2 : 1;
        const antes = document.createDocumentFragment();
        const depois = document.createDocumentFragment();
        for (let v = 0; v < voltas; v++) {
          this.originais.forEach((o) => depois.appendChild(this.clonar(o)));
        }
        for (let i = 0; i < this.porVez; i++) {
          const idx = this.originais.length - 1 - (i % this.originais.length);
          antes.insertBefore(this.clonar(this.originais[idx]), antes.firstChild);
        }
        this.track.insertBefore(antes, this.track.firstChild);
        this.track.appendChild(depois);
      }

      this.classList.toggle('cdrlc--sem-loop', !this.temLoop);
      this.classList.toggle('cdrlc--esteira', this.auto && this.temLoop);
      this.indice = 0;
      this.offset = 0;
      this.medir();
      if (this.auto) this.iniciarEsteira();
    }

    clonar(no) {
      const c = no.cloneNode(true);
      c.setAttribute('data-cdrlc-clone', 'true');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach((e) => e.removeAttribute('id'));
      c.querySelectorAll('a, button, input, select, textarea').forEach((e) => {
        e.tabIndex = -1;
      });
      return c;
    }

    medir() {
      const largura = this.viewport.clientWidth;
      const fixa = this.larguraFixaMobile();
      const item = fixa || (largura - (this.porVez - 1) * this.gap) / this.porVez;
      this.passo = item + this.gap;
      this.loopW = this.originais.length * this.passo;
      Array.from(this.track.children).forEach((s) => {
        s.style.flex = '0 0 ' + item + 'px';
        s.style.width = item + 'px';
      });
      this.posicionar(false);
    }

    base() {
      return this.temLoop ? this.porVez * this.passo : 0;
    }

    deslocamento() {
      if (this.auto) return -(this.base() + this.offset);
      return -(this.base() + this.indice * this.passo);
    }

    posicionar(animar) {
      this.track.style.transition = animar ? `transform ${this.speed}ms cubic-bezier(.22,.61,.36,1)` : 'none';
      this.track.style.transform = `translate3d(${this.deslocamento()}px, 0, 0)`;
      if (!animar) this.track.getBoundingClientRect();
    }

    /* ================= esteira ================= */
    iniciarEsteira() {
      cancelAnimationFrame(this.raf);
      if (!this.auto || !this.temLoop || this.semMovimento) return;

      let anterior = null;
      const frame = (agora) => {
        if (anterior === null) anterior = agora;
        /* trava o passo grande de quando a aba fica em segundo plano */
        const dt = Math.min(64, agora - anterior) / 1000;
        anterior = agora;

        if (!this.pausado && !this.arrastando) {
          let avanco = this.velocidade * dt;
          if (this.impulso) {
            const parcela = this.impulso * Math.min(1, dt * 4);
            avanco += parcela;
            this.impulso -= parcela;
            if (Math.abs(this.impulso) < 0.5) this.impulso = 0;
          }
          this.andar(avanco);
        }
        this.raf = requestAnimationFrame(frame);
      };
      this.raf = requestAnimationFrame(frame);
    }

    andar(px) {
      this.offset += px;
      /* volta ao comeÃ§o quando completa um conjunto: como o conteÃºdo se
         repete, a emenda nÃ£o aparece */
      while (this.offset >= this.loopW) this.offset -= this.loopW;
      while (this.offset < 0) this.offset += this.loopW;
      this.posicionar(false);
    }

    /* ================= passo a passo ================= */
    concluir() {
      clearTimeout(this.destravar);
      if (this.aoTerminar) {
        this.track.removeEventListener('transitionend', this.aoTerminar);
        this.aoTerminar = null;
      }
      const total = this.originais.length;
      if (this.temLoop && (this.indice >= total || this.indice < 0)) {
        this.indice = ((this.indice % total) + total) % total;
      }
      /* reafirma a posiÃ§Ã£o final mesmo se a transiÃ§Ã£o foi interrompida */
      this.posicionar(false);
      this.emTransicao = false;
    }

    mover(direcao) {
      /* na esteira, a seta sÃ³ dÃ¡ um empurrÃ£o no sentido escolhido */
      if (this.auto) {
        if (!this.temLoop) return;
        this.impulso += direcao * this.passo;
        return;
      }

      const total = this.originais.length;

      if (!this.temLoop) {
        this.indice = Math.min(Math.max(this.indice + direcao, 0), Math.max(0, total - this.porVez));
        this.posicionar(true);
        return;
      }

      if (this.emTransicao) this.concluir();

      this.emTransicao = true;
      this.indice += direcao;
      this.posicionar(true);

      this.aoTerminar = () => this.concluir();
      this.track.addEventListener('transitionend', this.aoTerminar);
      this.destravar = setTimeout(this.aoTerminar, this.speed + 120);
    }

    /* ================= arraste ================= */
    ligarArraste() {
      let x0 = 0;
      let ultimo = 0;
      let dx = 0;
      let base = 0;

      const inicio = (e) => {
        if (e.button === 2) return;
        if (!this.auto && this.emTransicao) return;
        this.arrastando = true;
        dx = 0;
        x0 = e.clientX;
        ultimo = e.clientX;
        base = this.deslocamento();
        this.track.style.transition = 'none';
        this.capturou = false;
      };

      const meio = (e) => {
        if (!this.arrastando) return;
        dx = e.clientX - x0;
        if (Math.abs(dx) < 4) return;
        if (!this.capturou) {
          if (this.viewport.setPointerCapture) {
            try { this.viewport.setPointerCapture(e.pointerId); } catch (_) {}
          }
          this.capturou = true;
        }
        if (this.auto) {
          this.andar(ultimo - e.clientX);
          ultimo = e.clientX;
        } else {
          this.track.style.transform = `translate3d(${base + dx}px, 0, 0)`;
        }
      };

      const fim = () => {
        if (!this.arrastando) return;
        this.arrastando = false;
        if (this.auto) {
          dx = 0;
          return;
        }
        const limite = Math.max(40, this.passo * 0.18);
        if (Math.abs(dx) > limite) this.mover(dx < 0 ? 1 : -1);
        else this.posicionar(true);
        dx = 0;
      };

      this.onDown = inicio;
      this.onMove = meio;
      this.onUp = fim;
      this.viewport.addEventListener('pointerdown', inicio);
      this.viewport.addEventListener('pointermove', meio);
      this.viewport.addEventListener('pointerup', fim);
      this.viewport.addEventListener('pointercancel', fim);
      this.viewport.addEventListener('pointerleave', fim);
      this.onClick = (e) => {
        if (Math.abs(dx) > 6) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      this.viewport.addEventListener('click', this.onClick, true);
      this.onDrag = (e) => e.preventDefault();
      this.viewport.addEventListener('dragstart', this.onDrag);
    }

    desligarArraste() {
      if (!this.viewport) return;
      this.viewport.removeEventListener('pointerdown', this.onDown);
      this.viewport.removeEventListener('pointermove', this.onMove);
      this.viewport.removeEventListener('pointerup', this.onUp);
      this.viewport.removeEventListener('pointercancel', this.onUp);
      this.viewport.removeEventListener('pointerleave', this.onUp);
      this.viewport.removeEventListener('click', this.onClick, true);
      this.viewport.removeEventListener('dragstart', this.onDrag);
    }
  }

  customElements.define('cdr-loop-carousel', CdrLoopCarousel);
})();
